import { createComponentSchema } from '../../../common/createComponentSchema';
import { trpc } from '../../lib/trpc';
import { zodResolver } from '@hookform/resolvers/zod';
import { Button, Space, TextInput } from '@mantine/core';
import { modals } from '@mantine/modals';
import { notifications } from '@mantine/notifications';
import { BadgeAlert, BadgeCheck } from 'lucide-react';
import { type FC } from 'react';
import { useForm } from 'react-hook-form';

export const Wizard: FC<{ readonly modalId: string }> = ({ modalId }) => {
  const { formState, handleSubmit, register } = useForm({
    defaultValues: {
      name: '',
      schema: { fields: [], version: 1 as const },
    },
    resolver: zodResolver(createComponentSchema),
  });
  const { mutateAsync: createComponentAsync } =
    trpc.components.create.useMutation();
  const utils = trpc.useUtils();

  const submitHandler = handleSubmit(async (data) => {
    try {
      await createComponentAsync(data);

      notifications.show({
        message: (
          <>
            <BadgeCheck stroke="var(--color-lime-400)" /> Component created
          </>
        ),
      });
      utils.components.invalidate();
      modals.close(modalId);
    } catch {
      notifications.show({
        message: (
          <>
            <BadgeAlert stroke="var(--color-red-400)" /> An error occurred.
            Please try again.
          </>
        ),
      });
    }
  });

  return (
    <form onSubmit={submitHandler}>
      <TextInput
        label="Name"
        {...register('name')}
        error={formState.errors.name?.message}
      />
      <Space h="lg" />
      <Button type="submit">Create</Button>
    </form>
  );
};
